import Route from "../../../router/Route";
import { RouterView } from "vue-router";

export default new Route("hierarchy", "/hierarchy", RouterView, [
	new Route("index", "", () => import("../pages/Hierarchies.vue"), []),
	new Route(
		"graph",
		"/hierarchy/:id/graph",
		() => import("../pages/Graph.vue"),
		[]
	),
]);
